import type { IModularBenefitDetail } from '@ben/shared/types/columbia';
import ManageBenefitFeatures from '@ben/shared/components/manage-benefit-features';
import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

interface BenefitFeaturesProps {
  benefitId: string;
}

const BenefitFeatures = ({ benefitId }: BenefitFeaturesProps) => {
  const { control } = useFormContext<IModularBenefitDetail>();

  return (
    <Controller
      name="features"
      control={control}
      render={({ field }) => {
        const { value, onChange } = field;
        return (
          <ManageBenefitFeatures
            features={value ?? []}
            onChange={onChange}
            showRankField
            benefitId={benefitId}
          />
        );
      }}
    />
  );
};

export default memo(BenefitFeatures);
